import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const SelectContentModal = ({ isOpen, onClose }: Props) => {
  const navigate = useNavigate();

  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} contentClassName='!max-w-xl'>
      <div>
        <div className='mt-3'>
          <h4 className='font-extrabold text-xl text-center'>Select content to upload</h4>
          <p className='font-semibold text-sm text-center text-gray-6/60'>
            Lorem ipsum dolor sit amet consectetur. Volutpat pulvi
          </p>
        </div>
        <div className='flex mt-10 pb-5 justify-center gap-8'>
          <div className='bg-gray-1/40 rounded-lg p-3 min-h-60 flex justify-center items-center'>
            <div>
              <h5 className='font-bold text-lg text-center'>Upload photos</h5>
              <p className='font-semibold text-sm text-center text-gray-6/60 mt-1 mb-7'>
                PNG, JPG Format acceptable
              </p>

              <Button
                onClick={() => navigate(ROUTE_KEYS.PHOTO_CONTENT)}
                color='primary'
                variant='block'
                className='py-2 w-28 text-sm font-medium mx-auto'>
                Select Photo
              </Button>
            </div>
          </div>
          <div className='bg-gray-1/40 rounded-lg p-3 min-h-60 flex justify-center items-center'>
            <div>
              <h5 className='font-bold text-lg text-center'>Upload Videos</h5>
              <p className='font-semibold text-sm text-center text-gray-6/60 mt-1 mb-7'>
                PNG, JPG Format acceptable
              </p>

              <Button
                onClick={() => navigate(ROUTE_KEYS.VIDEO_CONTENT)}
                color='primary'
                variant='block'
                className='py-2 w-28 text-sm font-medium mx-auto'>
                Select Video
              </Button>
            </div>
          </div>
        </div>
      </div>
    </LocalModal>
  );
};

export default SelectContentModal;
